/**
 * arloSimilarFallback.js - Choose the PDP "More Like This" source.
 *
 * Arlo's similar rail is preferred only when it resolves to a full-enough set;
 * a stubby Arlo rail (long-tail titles Arlo's catalog barely covers) is worse
 * than the catalog's category-adjacency rail. Below the threshold — including
 * the zero case while /v1/embed/similar is undeployed — we fall back, so the
 * PDP renders exactly what it renders today.
 */
export const MIN_ARLO_ITEMS = 4;

export const pickRelatedItems = (arloItems, catalogItems) => {
  const arlo = arloItems || [];
  if (arlo.length >= MIN_ARLO_ITEMS) {
    return { items: arlo, source: 'arlo' };
  }
  return { items: catalogItems || [], source: 'catalog' };
};
